import { f as r } from "./fails.js";
import { g as o } from "./global.js";
var s = o.RegExp,
  a = r(function () {
    var r = s(".", "s");
    return !(r.dotAll && r.exec("\n") && "s" === r.flags);
  });
export { a as r };